module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-striped",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Outras requisições\n          "), (_vm.hasNewer(_vm.sortedItems, _vm.request.objectId)) ? _c('span', {
    staticClass: "glyphicon glyphicon-warning-sign",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "Existem requisições mais novas!"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right clickable show-more",
    on: {
      "click": function($event) {
        _vm.showRequestData = !_vm.showRequestData
      }
    }
  }, [_vm._v(_vm._s(!_vm.showRequestData ? 'Mostrar' : 'Esconder'))])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showRequestData) ? _c('tbody', [_c('tr', [_c('th', [_vm._v("Requisição")]), _vm._v(" "), _c('th', [_vm._v("Data")])]), _vm._v(" "), _vm._l((_vm.linked), function(element) {
    return _c('tr', {
      key: element.objectId
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/request/' + element.objectId
        },
        "replace": "",
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(element.objectId) + " ")]), _vm._v(" "), (_vm.hasNewer(_vm.sortedItems, element.objectId)) ? _c('span', {
      staticClass: "glyphicon glyphicon-warning-sign",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "title": "Existem requisições mais novas!"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatDate(element.createdAt)))])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12fb48ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestUserLinked.vue
// module id = 1435
// module chunks = 1